"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.use = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
function omit(object, ...paths) {
    const keys = Object.keys(object);
    const result = {};
    for (const key of keys) {
        if (paths.indexOf(key) === -1) {
            result[key] = object[key];
        }
    }
    return result;
}
function toArray(arg) {
    if (typeof arg === 'undefined') {
        return [];
    }
    return Array.isArray(arg) ? arg : [arg];
}
function arrayContainsArray(superset, subset) {
    if (superset.length < subset.length) {
        return false;
    }
    for (const value of subset) {
        if (superset.indexOf(value) === -1) {
            return false;
        }
    }
    return true;
}
const Use = React.forwardRef((props, ref) => render(Object.assign(omit(props, 'useNext'), { ref, use: props.useNext })));
function render(props) {
    const [Component, ...useNext] = toArray(props.use).filter((x, i, arr) => x !== Use && (typeof x !== 'string' || i === arr.length - 1));
    if (!Component) {
        return null;
    }
    const finalProps = omit(props, 'use', 'useNext');
    if (!useNext.length || typeof Component === 'string') {
        return React.createElement(Component, Object.assign({}, finalProps));
    }
    if (useNext.length === 1) {
        return React.createElement(Component, Object.assign({}, finalProps, { use: useNext[0] }));
    }
    return React.createElement(Component, Object.assign({}, props, { use: Use, useNext: useNext }));
}
function isUseComponent(component) {
    return component && Array.isArray(component.uses);
}
function use(...uses) {
    const [First, ...next] = uses;
    if (isUseComponent(First) && arrayContainsArray(First.uses, next)) {
        return First;
    }
    const Component = React.forwardRef((props, ref) => render(Object.assign(omit(props, 'useNext'), {
        ref,
        use: [...uses, ...toArray(props.use), ...toArray(props.useNext)],
    })));
    Component.uses = uses;
    return Component;
}
exports.use = use;

//# sourceMappingURL=use.js.map
